import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AdvantagesSection from './components/AdvantagesSection';
import SolutionsSection from './components/SolutionsSection';
import BenefitsSection from './components/BenefitsSection';
import TechnicalSection from './components/TechnicalSection';
import FinancingSection from './components/FinancingSection';
import ProcessSection from './components/ProcessSection';
import ResultsSection from './components/ResultsSection';
import CTASection from './components/CTASection';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SchemaOrg from '../../components/feature/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

const deshuSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Service',
      '@id': `${siteUrl}/deshumidificateurs#service`,
      name: 'Déshumidificateurs pour serres - AIRPURE',
      provider: {
        '@type': 'Organization',
        name: 'AIRPURE',
        url: siteUrl,
        telephone: '+33189293323',
      },
      description:
        "Solutions de déshumidification professionnelles pour serres agricoles et horticoles. Contrôle optimal de l'hygrométrie pour améliorer les rendements, réduire les maladies et optimiser la consommation d'énergie.",
      areaServed: { '@type': 'Country', name: 'France' },
      url: `${siteUrl}/deshumidificateurs`,
      serviceType: 'Installation et maintenance de déshumidificateurs',
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Gamme déshumidificateurs serres',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Déshumidificateur serre maraîchère',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Product',
              name: 'Déshumidificateur serre horticole',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Financement CEE déshumidificateur',
            },
          },
        ],
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/deshumidificateurs#webpage`,
      url: `${siteUrl}/deshumidificateurs`,
      name: 'Déshumidificateurs pour serres AIRPURE | Solutions hygrométrie agricole France',
      description:
        "Spécialiste des déshumidificateurs pour serres en France. Contrôle optimal de l'humidité, financement CEE disponible. Améliorez vos rendements avec AIRPURE.",
      inLanguage: 'fr-FR',
      isPartOf: { '@type': 'WebSite', name: 'AIRPURE', url: siteUrl },
      about: { '@id': `${siteUrl}/deshumidificateurs#service` },
    },
  ],
};

export default function DeshumidificateursPage() {
  useEffect(() => {
    document.title =
      'Déshumidificateurs pour serres AIRPURE | Solutions hygrométrie agricole France';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        "Spécialiste des déshumidificateurs pour serres en France. Contrôle optimal de l'humidité, financement CEE disponible. Améliorez vos rendements avec AIRPURE.",
      );
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${siteUrl}/deshumidificateurs`);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg schema={deshuSchema} id="schema-deshumidificateurs" />
      <HeroSection />
      <AdvantagesSection />
      <SolutionsSection />
      <BenefitsSection />
      <TechnicalSection />
      <FinancingSection />
      <ProcessSection />
      <ResultsSection />
      <CTASection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
